import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { isSioHost } from '@systemeio/util';
import { settingsMenuHref } from 'modules/profile/constants/settings-menu-href';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { SettingsMenuEnum } from 'modules/profile/enums/settings-menu-enum';
import { SettingsMenuInterface } from 'modules/profile/types/settings-interface';
import { getMenuItemDataTestId } from 'modules/profile/utils/get-menu-item-data-test-id';
import { useRouter } from 'next/router';
import { AdminRolesEnum } from 'shared/enums/user-roles-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { GrowthbookFlagsEnum } from 'growthbook/types';
export const useSettingsMenuItems = () => {
  const $ = _c(175);
  const {
    t
  } = useLocoTranslation();
  const {
    isWorkspaceOwner,
    isWsAdmin,
    isCustomer,
    isAffiliate,
    isStudent,
    checkImpersonatorAdminRoles,
    isSupportImpersonation,
    isSubAccountImpersonation
  } = useUser();
  const {
    pathname
  } = useRouter();
  let t0;
  if ($[0] !== pathname) {
    t0 = url => pathname.includes(url);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const regularIsActiveCheck = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t(settingsMenuLocoKeys[SettingsMenuEnum.profile]);
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = (isCustomer || isAffiliate) && isWorkspaceOwner;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getMenuItemDataTestId(SettingsMenuEnum.profile);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== regularIsActiveCheck || $[6] !== t1 || $[7] !== t2) {
    t4 = {
      name: t1,
      href: settingsMenuHref[SettingsMenuEnum.profile],
      shouldRender: t2,
      dataTestId: t3,
      isActive: regularIsActiveCheck
    };
    $[5] = regularIsActiveCheck;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(settingsMenuLocoKeys[SettingsMenuEnum.account]);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = isCustomer || isStudent;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getMenuItemDataTestId(SettingsMenuEnum.account);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== regularIsActiveCheck || $[13] !== t5 || $[14] !== t6) {
    t8 = {
      name: t5,
      href: settingsMenuHref[SettingsMenuEnum.account],
      shouldRender: t6,
      dataTestId: t7,
      isActive: regularIsActiveCheck
    };
    $[12] = regularIsActiveCheck;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t(settingsMenuLocoKeys[SettingsMenuEnum.my_plan]);
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = isCustomer && isWorkspaceOwner;
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = getMenuItemDataTestId(SettingsMenuEnum.my_plan);
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== regularIsActiveCheck || $[20] !== t10 || $[21] !== t9) {
    t12 = {
      name: t9,
      href: settingsMenuHref[SettingsMenuEnum.my_plan],
      shouldRender: t10,
      dataTestId: t11,
      isActive: regularIsActiveCheck
    };
    $[19] = regularIsActiveCheck;
    $[20] = t10;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t(settingsMenuLocoKeys[SettingsMenuEnum.payment_gateways]);
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = isCustomer && isWorkspaceOwner;
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getMenuItemDataTestId(SettingsMenuEnum.payment_gateways);
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== regularIsActiveCheck || $[27] !== t13 || $[28] !== t14) {
    t16 = {
      name: t13,
      href: settingsMenuHref[SettingsMenuEnum.payment_gateways],
      shouldRender: t14,
      dataTestId: t15,
      isActive: regularIsActiveCheck
    };
    $[26] = regularIsActiveCheck;
    $[27] = t13;
    $[28] = t14;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t(settingsMenuLocoKeys[SettingsMenuEnum.manage_subscriptions]);
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = (isCustomer || isStudent) && isWorkspaceOwner;
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = getMenuItemDataTestId(SettingsMenuEnum.manage_subscriptions);
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== regularIsActiveCheck || $[34] !== t17 || $[35] !== t18) {
    t20 = {
      name: t17,
      href: settingsMenuHref[SettingsMenuEnum.manage_subscriptions],
      shouldRender: t18,
      dataTestId: t19,
      isActive: regularIsActiveCheck
    };
    $[33] = regularIsActiveCheck;
    $[34] = t17;
    $[35] = t18;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t(settingsMenuLocoKeys[SettingsMenuEnum.mailing]);
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = getMenuItemDataTestId(SettingsMenuEnum.mailing);
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== isCustomer || $[41] !== regularIsActiveCheck || $[42] !== t21) {
    t23 = {
      name: t21,
      href: settingsMenuHref[SettingsMenuEnum.mailing],
      shouldRender: isCustomer,
      dataTestId: t22,
      isActive: regularIsActiveCheck
    };
    $[40] = isCustomer;
    $[41] = regularIsActiveCheck;
    $[42] = t21;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t) {
    t24 = t(settingsMenuLocoKeys[SettingsMenuEnum.membership]);
    $[44] = t;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = getMenuItemDataTestId(SettingsMenuEnum.membership);
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== isCustomer || $[48] !== regularIsActiveCheck || $[49] !== t24) {
    t26 = {
      name: t24,
      href: settingsMenuHref[SettingsMenuEnum.membership],
      shouldRender: isCustomer,
      dataTestId: t25,
      isActive: regularIsActiveCheck
    };
    $[47] = isCustomer;
    $[48] = regularIsActiveCheck;
    $[49] = t24;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t) {
    t27 = t(settingsMenuLocoKeys[SettingsMenuEnum.payment_page]);
    $[51] = t;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  const t28 = isCustomer && (isWorkspaceOwner || isWsAdmin);
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = getMenuItemDataTestId(SettingsMenuEnum.payment_page);
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== regularIsActiveCheck || $[55] !== t27 || $[56] !== t28) {
    t30 = {
      name: t27,
      href: settingsMenuHref[SettingsMenuEnum.payment_page],
      shouldRender: t28,
      dataTestId: t29,
      isActive: regularIsActiveCheck
    };
    $[54] = regularIsActiveCheck;
    $[55] = t27;
    $[56] = t28;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== t) {
    t31 = t(settingsMenuLocoKeys[SettingsMenuEnum.sales_funnel]);
    $[58] = t;
    $[59] = t31;
  } else {
    t31 = $[59];
  }
  let t32;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = getMenuItemDataTestId(SettingsMenuEnum.sales_funnel);
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== isCustomer || $[62] !== regularIsActiveCheck || $[63] !== t31) {
    t33 = {
      name: t31,
      href: settingsMenuHref[SettingsMenuEnum.sales_funnel],
      shouldRender: isCustomer,
      dataTestId: t32,
      isActive: regularIsActiveCheck
    };
    $[61] = isCustomer;
    $[62] = regularIsActiveCheck;
    $[63] = t31;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== t) {
    t34 = t(settingsMenuLocoKeys[SettingsMenuEnum.shipping]);
    $[65] = t;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  const t35 = isCustomer && isWorkspaceOwner;
  let t36;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = getMenuItemDataTestId(SettingsMenuEnum.shipping);
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== regularIsActiveCheck || $[69] !== t34 || $[70] !== t35) {
    t37 = {
      name: t34,
      href: settingsMenuHref[SettingsMenuEnum.shipping],
      shouldRender: t35,
      dataTestId: t36,
      isActive: regularIsActiveCheck
    };
    $[68] = regularIsActiveCheck;
    $[69] = t34;
    $[70] = t35;
    $[71] = t37;
  } else {
    t37 = $[71];
  }
  let t38;
  if ($[72] !== t) {
    t38 = t(settingsMenuLocoKeys[SettingsMenuEnum.affiliate_program]);
    $[72] = t;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] !== isCustomer || $[75] !== isWorkspaceOwner) {
    t39 = isCustomer && isWorkspaceOwner && isSioHost(window.location.host);
    $[74] = isCustomer;
    $[75] = isWorkspaceOwner;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = getMenuItemDataTestId(SettingsMenuEnum.affiliate_program);
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] !== regularIsActiveCheck || $[79] !== t38 || $[80] !== t39) {
    t41 = {
      name: t38,
      href: settingsMenuHref[SettingsMenuEnum.affiliate_program],
      shouldRender: t39,
      dataTestId: t40,
      isActive: regularIsActiveCheck
    };
    $[78] = regularIsActiveCheck;
    $[79] = t38;
    $[80] = t39;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  let t42;
  if ($[82] !== t) {
    t42 = t(settingsMenuLocoKeys[SettingsMenuEnum.custom_domains]);
    $[82] = t;
    $[83] = t42;
  } else {
    t42 = $[83];
  }
  const t43 = isCustomer && isWorkspaceOwner;
  let t44;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = getMenuItemDataTestId(SettingsMenuEnum.custom_domains);
    $[84] = t44;
  } else {
    t44 = $[84];
  }
  let t45;
  if ($[85] !== regularIsActiveCheck || $[86] !== t42 || $[87] !== t43) {
    t45 = {
      name: t42,
      href: settingsMenuHref[SettingsMenuEnum.custom_domains],
      shouldRender: t43,
      dataTestId: t44,
      isActive: regularIsActiveCheck
    };
    $[85] = regularIsActiveCheck;
    $[86] = t42;
    $[87] = t43;
    $[88] = t45;
  } else {
    t45 = $[88];
  }
  let t46;
  if ($[89] !== t) {
    t46 = t("dashboard.user_settings.public_api.title_plural");
    $[89] = t;
    $[90] = t46;
  } else {
    t46 = $[90];
  }
  let t47;
  if ($[91] !== isCustomer || $[92] !== isWorkspaceOwner || $[93] !== isWsAdmin) {
    t47 = isCustomer && (isWorkspaceOwner || isWsAdmin) && isSioHost(window.location.host);
    $[91] = isCustomer;
    $[92] = isWorkspaceOwner;
    $[93] = isWsAdmin;
    $[94] = t47;
  } else {
    t47 = $[94];
  }
  let t48;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = getMenuItemDataTestId(SettingsMenuEnum.public_api);
    $[95] = t48;
  } else {
    t48 = $[95];
  }
  let t49;
  if ($[96] !== regularIsActiveCheck || $[97] !== t46 || $[98] !== t47) {
    t49 = {
      name: t46,
      href: settingsMenuHref[SettingsMenuEnum.public_api],
      shouldRender: t47,
      dataTestId: t48,
      isActive: regularIsActiveCheck
    };
    $[96] = regularIsActiveCheck;
    $[97] = t46;
    $[98] = t47;
    $[99] = t49;
  } else {
    t49 = $[99];
  }
  let t50;
  if ($[100] !== t) {
    t50 = t(settingsMenuLocoKeys[SettingsMenuEnum.webhooks]);
    $[100] = t;
    $[101] = t50;
  } else {
    t50 = $[101];
  }
  let t51;
  if ($[102] !== isCustomer || $[103] !== isWorkspaceOwner || $[104] !== isWsAdmin) {
    t51 = isCustomer && (isWorkspaceOwner || isWsAdmin) && isSioHost(window.location.host);
    $[102] = isCustomer;
    $[103] = isWorkspaceOwner;
    $[104] = isWsAdmin;
    $[105] = t51;
  } else {
    t51 = $[105];
  }
  let t52;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = getMenuItemDataTestId(SettingsMenuEnum.webhooks);
    $[106] = t52;
  } else {
    t52 = $[106];
  }
  let t53;
  if ($[107] !== regularIsActiveCheck || $[108] !== t50 || $[109] !== t51) {
    t53 = {
      name: t50,
      href: settingsMenuHref[SettingsMenuEnum.webhooks],
      shouldRender: t51,
      dataTestId: t52,
      isActive: regularIsActiveCheck
    };
    $[107] = regularIsActiveCheck;
    $[108] = t50;
    $[109] = t51;
    $[110] = t53;
  } else {
    t53 = $[110];
  }
  let t54;
  if ($[111] !== t) {
    t54 = t(settingsMenuLocoKeys[SettingsMenuEnum.integrations]);
    $[111] = t;
    $[112] = t54;
  } else {
    t54 = $[112];
  }
  const t55 = isCustomer && (isWorkspaceOwner || isWsAdmin);
  let t56;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = getMenuItemDataTestId(SettingsMenuEnum.integrations);
    $[113] = t56;
  } else {
    t56 = $[113];
  }
  let t57;
  if ($[114] !== regularIsActiveCheck || $[115] !== t54 || $[116] !== t55) {
    t57 = {
      name: t54,
      href: settingsMenuHref[SettingsMenuEnum.integrations],
      shouldRender: t55,
      dataTestId: t56,
      isActive: regularIsActiveCheck
    };
    $[114] = regularIsActiveCheck;
    $[115] = t54;
    $[116] = t55;
    $[117] = t57;
  } else {
    t57 = $[117];
  }
  let t58;
  if ($[118] !== t) {
    t58 = t(settingsMenuLocoKeys[SettingsMenuEnum.affiliate_commissions]);
    $[118] = t;
    $[119] = t58;
  } else {
    t58 = $[119];
  }
  let t59;
  if ($[120] !== isAffiliate || $[121] !== isCustomer || $[122] !== isWorkspaceOwner) {
    t59 = (isCustomer || isAffiliate) && isWorkspaceOwner && isSioHost(window.location.host);
    $[120] = isAffiliate;
    $[121] = isCustomer;
    $[122] = isWorkspaceOwner;
    $[123] = t59;
  } else {
    t59 = $[123];
  }
  let t60;
  if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = getMenuItemDataTestId(SettingsMenuEnum.affiliate_commissions);
    $[124] = t60;
  } else {
    t60 = $[124];
  }
  let t61;
  if ($[125] !== regularIsActiveCheck || $[126] !== t58 || $[127] !== t59) {
    t61 = {
      name: t58,
      href: settingsMenuHref[SettingsMenuEnum.affiliate_commissions],
      shouldRender: t59,
      dataTestId: t60,
      isActive: regularIsActiveCheck
    };
    $[125] = regularIsActiveCheck;
    $[126] = t58;
    $[127] = t59;
    $[128] = t61;
  } else {
    t61 = $[128];
  }
  let t62;
  if ($[129] !== t) {
    t62 = t(settingsMenuLocoKeys[SettingsMenuEnum.notification]);
    $[129] = t;
    $[130] = t62;
  } else {
    t62 = $[130];
  }
  let t63;
  if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = getMenuItemDataTestId(SettingsMenuEnum.notification);
    $[131] = t63;
  } else {
    t63 = $[131];
  }
  let t64;
  if ($[132] !== regularIsActiveCheck || $[133] !== t62) {
    t64 = {
      name: t62,
      href: settingsMenuHref[SettingsMenuEnum.notification],
      shouldRender: true,
      dataTestId: t63,
      isActive: regularIsActiveCheck
    };
    $[132] = regularIsActiveCheck;
    $[133] = t62;
    $[134] = t64;
  } else {
    t64 = $[134];
  }
  let t65;
  if ($[135] !== t) {
    t65 = t(settingsMenuLocoKeys[SettingsMenuEnum.workspace_members]);
    $[135] = t;
    $[136] = t65;
  } else {
    t65 = $[136];
  }
  let t66;
  if ($[137] !== isCustomer || $[138] !== isWorkspaceOwner || $[139] !== isWsAdmin) {
    t66 = isCustomer && (isWorkspaceOwner || isWsAdmin) && isSioHost(window.location.host);
    $[137] = isCustomer;
    $[138] = isWorkspaceOwner;
    $[139] = isWsAdmin;
    $[140] = t66;
  } else {
    t66 = $[140];
  }
  let t67;
  if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = getMenuItemDataTestId(SettingsMenuEnum.workspace_members);
    $[141] = t67;
  } else {
    t67 = $[141];
  }
  let t68;
  if ($[142] !== regularIsActiveCheck || $[143] !== t65 || $[144] !== t66) {
    t68 = {
      name: t65,
      href: settingsMenuHref[SettingsMenuEnum.workspace_members],
      shouldRender: t66,
      dataTestId: t67,
      isActive: regularIsActiveCheck
    };
    $[142] = regularIsActiveCheck;
    $[143] = t65;
    $[144] = t66;
    $[145] = t68;
  } else {
    t68 = $[145];
  }
  let t69;
  if ($[146] !== t) {
    t69 = t(settingsMenuLocoKeys[SettingsMenuEnum.change_password]);
    $[146] = t;
    $[147] = t69;
  } else {
    t69 = $[147];
  }
  let t70;
  bb0: {
    if (isSubAccountImpersonation) {
      t70 = false;
      break bb0;
    }
    if (isSupportImpersonation) {
      let t71;
      if ($[148] !== checkImpersonatorAdminRoles) {
        t71 = checkImpersonatorAdminRoles([AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
        $[148] = checkImpersonatorAdminRoles;
        $[149] = t71;
      } else {
        t71 = $[149];
      }
      t70 = t71;
      break bb0;
    }
    t70 = isWorkspaceOwner;
  }
  let t71;
  if ($[150] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = getMenuItemDataTestId(SettingsMenuEnum.change_password);
    $[150] = t71;
  } else {
    t71 = $[150];
  }
  let t72;
  if ($[151] !== regularIsActiveCheck || $[152] !== t69 || $[153] !== t70) {
    t72 = {
      name: t69,
      href: settingsMenuHref[SettingsMenuEnum.change_password],
      shouldRender: t70,
      dataTestId: t71,
      isActive: regularIsActiveCheck
    };
    $[151] = regularIsActiveCheck;
    $[152] = t69;
    $[153] = t70;
    $[154] = t72;
  } else {
    t72 = $[154];
  }
  let t73;
  if ($[155] !== t12 || $[156] !== t16 || $[157] !== t20 || $[158] !== t23 || $[159] !== t26 || $[160] !== t30 || $[161] !== t33 || $[162] !== t37 || $[163] !== t4 || $[164] !== t41 || $[165] !== t45 || $[166] !== t49 || $[167] !== t53 || $[168] !== t57 || $[169] !== t61 || $[170] !== t64 || $[171] !== t68 || $[172] !== t72 || $[173] !== t8) {
    t73 = [t4, t8, t12, t16, t20, t23, t26, t30, t33, t37, t41, t45, t49, t53, t57, t61, t64, t68, t72];
    $[155] = t12;
    $[156] = t16;
    $[157] = t20;
    $[158] = t23;
    $[159] = t26;
    $[160] = t30;
    $[161] = t33;
    $[162] = t37;
    $[163] = t4;
    $[164] = t41;
    $[165] = t45;
    $[166] = t49;
    $[167] = t53;
    $[168] = t57;
    $[169] = t61;
    $[170] = t64;
    $[171] = t68;
    $[172] = t72;
    $[173] = t8;
    $[174] = t73;
  } else {
    t73 = $[174];
  }
  const menuItems = t73;
  return menuItems;
};